const money = (value) =>
  Number(value || 0).toLocaleString("es-CO", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

export default function InvoiceItemsTable({ items = [] }) {
  return (
    <section className="invoice-items">
      <h2>Productos o servicios</h2>

      <p>{items.length} artículo(s)</p>

      <div className="table-responsive">
        <table className="table invoice-table">
          <thead>
            <tr>
              <th>SKU</th>
              <th>Producto</th>
              <th className="text-center">No poder.</th>
              <th className="text-end">Vr. unitario</th>
              <th className="text-end">Total parcial</th>
              <th className="text-center">IVA</th>
              <th className="text-end">Total</th>
            </tr>
          </thead>

          <tbody>
            {items.length === 0 ? (
              <tr>
                <td colSpan="7" className="text-center py-4">
                  No existen productos registrados.
                </td>
              </tr>
            ) : (
              items.map((item) => {
                const subtotal = Number(item.subtotal || 0);
                const taxRate = Number(item.tax_rate || 0);

                const taxAmount = subtotal * (taxRate / 100);

                // El total se calcula aquí; no depende de item.total.
                const total = subtotal + taxAmount;

                return (
                  <tr key={item.id}>
                    <td>{item.sku}</td>

                    <td>
                      <strong>{item.product_name}</strong>

                      {item.tax_group_name && (
                        <>
                          <br />

                          <small className="text-muted">
                            Grupo tributario: {item.tax_group_name}
                          </small>
                        </>
                      )}
                    </td>

                    <td className="text-center">
                      {item.quantity}
                    </td>

                    <td className="text-end">
                      ${money(item.unit_price)}
                    </td>

                    <td className="text-end">
                      ${money(subtotal)}
                    </td>

                    <td className="text-center">
                      {taxRate} %
                    </td>

                    <td className="text-end fw-bold">
                      ${money(total)}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}